<template>
  <direct-debit-create :subNavTitle="title" :capsule="capsule" :saveMessage="saveMessage"></direct-debit-create>
</template>

<script>
  import CreateTemplate from '../../requests/creationPages/DDCreateTemplate.vue'
  export default {
    name: 'Capsule-Direct-Debit-Create',
    data: () => {
      return {
        title: 'New Modular Loan Request',
        capsule: 'direct-debit-create',
        saveMessage: 'Draft added'
      }
    },
    components: {
      'direct-debit-create': CreateTemplate
    }
  }
</script>



// WEBPACK FOOTER //
// TDirectDebitCreate.vue?fd56ce08